import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TierFormGroup, TierPricing } from './types';

export type TierArrayErrorReason = 'startNotOne' | 'minMaxInverted' | 'unlimitedNotLast' | 'discontiguous';

export interface TierArrayError {
    reason: TierArrayErrorReason;
    tierIndex?: number;
}

function validate(tiers: TierPricing[]): ValidationErrors | null {
    if (tiers.length === 0) {
        return null;
    }

    if (tiers[0].minUsers !== 1) {
        return { tiers: <TierArrayError>{ reason: 'startNotOne', tierIndex: 0 } };
    }

    for (let i = 0; i < tiers.length; i++) {
        const tier = tiers[i];
        const isLast = i === tiers.length - 1;

        if (!isLast && tier.maxUsers === null) {
            return { tiers: <TierArrayError>{ reason: 'unlimitedNotLast', tierIndex: i } };
        }

        if (tier.maxUsers !== null && tier.maxUsers < tier.minUsers) {
            return { tiers: <TierArrayError>{ reason: 'minMaxInverted', tierIndex: i } };
        }
    }

    for (let i = 0; i < tiers.length - 1; i++) {
        const current = tiers[i];
        const next = tiers[i + 1];

        if (current.maxUsers === null || next.minUsers !== current.maxUsers + 1) {
            return { tiers: <TierArrayError>{ reason: 'discontiguous', tierIndex: i + 1 } };
        }
    }

    return null;
}

export const tierArrayValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const array = <FormArray<TierFormGroup>>control;
    return validate(array.controls.map((group) => group.getRawValue()));
};
